import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { ScopedCssBaseline } from '../StyleBase';
import FormControl from './FormControl';
import FormControlLabel from './FormControlLabel';
import FormLabel from './FormLabel';
import FormGroup from './FormGroup';
import FormFeedback from './FormFeedback';
const Root = styled.form.withConfig({
  displayName: "Form__Root",
  componentId: "sc-1pjk5gr-0"
})(["", " display:block;margin:0;padding:0;"], ScopedCssBaseline);
const Form = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Root, _extends({}, props, {
  ref: ref
})));
Form.displayName = 'Form';
Form.Control = FormControl;
Form.ControlLabel = FormControlLabel;
Form.Label = FormLabel;
Form.Group = FormGroup;
Form.Feedback = FormFeedback;
export default Form;